const config = {
	url:'https://www.kortho.org/api',//
	url1:'https://www.kortho.org/server', //
	// url:'/api',//
	// url1:'/server', //
	// url:'http://106.12.186.114:8182',//
	// url1:'http://154.85.59.252:6868', //
}

export default config